import React, { useEffect, useState } from "react";
import {
  IonBackButton,
  IonBadge,
  IonButton,
  IonButtons,
  IonCard,
  IonCardContent,
  IonCardHeader,
  IonCardSubtitle,
  IonCardTitle,
  IonCol,
  IonContent,
  IonGrid,
  IonIcon,
  IonHeader,
  IonItem,
  IonLabel,
  IonList,
  IonMenuButton,
  IonPage,
  IonProgressBar,
  IonRow,
  IonTitle,
  IonToolbar
} from "@ionic/react";
import {
  calendarClear as calendarCleanIcon,
  key as keyIcon,
  podium as podiumIcon,
  logOut as logOutIcon
} from "ionicons/icons";
import {
  faArrowRightFromBracket,
  faKey,
  faCalendar,
  faClipboard,
  faEnvelope,
  faHouse
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Redirect } from "react-router";
import "./Menu.scss";
import { useLocalStorage } from "../hooks";
import lnbp_logo from "../icon/icon.png";

// unfocus icons
import news_icon from "./../icon/01_Calendario_Select.svg";
import teams_icon from "./../icon/01_Equipos_Select.svg";
import results_icon from "./../icon/01_Calendario_Select.svg";
import leaders_icon from "./../icon/01_LideresIndiv_Select.svg";
import score_icon from "./../icon/01_Resultados_Select.svg";

import calendar_icon from "./../icon/01_Calendario_Select.svg";
import video_icon from "./../icon/01_Video_Select.svg";
import trivia_icon from "./../icon/01_Trivias_Select.svg";
import home_icon from "./../icon/01_Home_Select.svg";
import more_icon from "./../icon/01_Mas_Select.svg";

// focus icons
import news_icon_select from "./../icon/01_Calendario.svg";
import teams_icon_select from "./../icon/01_Equipos.svg";
import results_icon_select from "./../icon/01_Calendario.svg";
import leaders_icon_select from "./../icon/01_LideresIndv.svg";
import score_icon_select from "./../icon/01_Resultados.svg";
import tabla_posiciones from "./../icon/01_TdePosiciones_Select.svg";

import calendar_icon_select from "./../icon/01_Calendario.svg";
import video_icon_select from "./../icon/01_Video.svg";
import trivia_icon_select from "./../icon/01_Trivias.svg";
import home_icon_select from "./../icon/01_Home.svg";
import more_icon_select from "./../icon/01_Mas.svg";

// social netowrks icons
import facebook_icon from "./../icon/01_facebook.svg";
import instagram_icon from "./../icon/01_Instagram.svg";
import twitter_icon from "./../icon/01_Twitter.svg";
import youtube_icon from "./../icon/01_Youtube.svg";
import coffeeTools from "../CoffeeTools";
import { dom } from "@fortawesome/fontawesome-svg-core";

const Menu: React.FC = () => {
  let base_url = process.env.REACT_APP_BASE_URL;
  let id_season = process.env.REACT_APP_ID_SEASON;
  let coffee_tools = new coffeeTools();
  const [showProgessBar, setShowProgessBar] = useState(true);

  const [homeIcon, SetHomeIcon] = useState(home_icon_select);
  const [calendarIcon, SetCalendarIcon] = useState(calendar_icon);
  const [videosIcon, SetVideosIcon] = useState(video_icon);
  const [resultsIcon, SetResultsIcon] = useState(results_icon);
  const [moreIcon, SetMoreIcon] = useState(more_icon);

  useEffect(() => {
    //start the page
    mainController.init();
    let coffee = new coffeeTools();
    // console.log(coffee.test(123));
  }, []);

  var controller = (() => {
    function getBanner(id_entry, callback) {
      var ajax_data = {
        id: id_entry
      };
      fetch(process.env.REACT_APP_BASE_URL + "/cms/entries/single", {
        method: "POST",
        body: JSON.stringify(ajax_data),
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json"
        }
      })
        .then((res) => res.json())
        .then((data) => {
          callback(data);
        });
    }
    function getSocialNetworkCompany(callback) {
      let company_id = 2; //lnbp company id
      fetch(base_url + "/business/companies/single", {
        method: "Post",
        credentials: "omit",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          id: company_id
        })
      })
        .then((response) => response.json())
        .then((response) => {
          callback(response);
        });
    }
    return {
      getBanner: (id_entry, callback) => getBanner(id_entry, callback),
      getSocialNetworkCompany: (callback) => getSocialNetworkCompany(callback)
    };
  })();

  let view = (() => {
    let dom_obj = {
      menu_side_banner: "js__menu_side__banner",
      menu_social_network: "js__menu_social_network"
    };

    // set active icon for the bottom tab
    // default home, 2 calendar, 3 videos, 4 results, 5 more
    function setActiveIcon(activeTab: number = 1) {
      switch (activeTab) {
        case 2:
          SetHomeIcon(home_icon);
          SetCalendarIcon(calendar_icon);
          SetVideosIcon(video_icon);
          SetResultsIcon(results_icon);
          SetMoreIcon(more_icon);
          break;
        case 3:
          SetHomeIcon(home_icon);
          SetCalendarIcon(calendar_icon);
          SetVideosIcon(video_icon);
          SetResultsIcon(results_icon);
          SetMoreIcon(more_icon);
          break;
        case 4:
          SetHomeIcon(home_icon);
          SetCalendarIcon(calendar_icon);
          SetVideosIcon(video_icon);
          SetResultsIcon(results_icon);
          SetMoreIcon(more_icon);
          break;
        case 5:
          SetHomeIcon(home_icon);
          SetCalendarIcon(calendar_icon);
          SetVideosIcon(video_icon);
          SetResultsIcon(results_icon);
          SetMoreIcon(more_icon);
          break;
        default:
          SetHomeIcon(home_icon_select);
          SetCalendarIcon(calendar_icon);
          SetVideosIcon(video_icon);
          SetResultsIcon(results_icon);
          SetMoreIcon(more_icon);
          break;
      }
    }
    // set active icon according to url path
    function setActivePage(url) {
      switch (url) {
        case "/home":
          setActiveIcon(1);
          break;
        case "/calendar":
          setActiveIcon(2);
          break;
        case "/videos":
          setActiveIcon(3);
          break;
        case "/scores":
          setActiveIcon(4);
          break;
        case "/more":
          setActiveIcon(5);
          break;
        default:
          setActiveIcon(1);
      }
    }
    /* Banner */
    function displayTopBanner(data) {
      // console.log("displayTopBanner");

      let image = document.getElementById(dom_obj.menu_side_banner);
      image.setAttribute(
        "src",
        process.env.REACT_APP_BASE_URL + data.item.full_url_image
      );

      if (
        data.item.full_url_image != null &&
        !data.item.full_url_image.includes("no-image.jpg")
      ) {
      }
    }
    function showSocialNetworkCompany(data) {
      let social_networks = document.getElementById(
        dom_obj.menu_social_network
      );
      social_networks.innerHTML = "";
      let social_networks_available = [];

      if (data.item.facebook_url != null) {
        let anchor = document.createElement("a");
        anchor.href = data.item.facebook_url;
        anchor.target = "_blank";
        anchor.className = "side-menu-social-network";
        anchor.rel = "noopener noreferrer";

        let icon = document.createElement("img");
        icon.src = facebook_icon;
        icon.alt = "Facebook";

        anchor.appendChild(icon);
        social_networks_available.push(anchor);
      }
      if (data.item.instagram_url != null) {
        let anchor = document.createElement("a");
        anchor.href = data.item.instagram_url;
        anchor.target = "_blank";
        anchor.className = "side-menu-social-network";
        anchor.rel = "noopener noreferrer";

        let icon = document.createElement("img");
        icon.src = instagram_icon;
        icon.alt = "Instagram";

        anchor.appendChild(icon);
        social_networks_available.push(anchor);
      }
      if (data.item.twitter_url != null) {
        let anchor = document.createElement("a");
        anchor.href = data.item.twitter_url;
        anchor.target = "_blank";
        anchor.className = "side-menu-social-network";
        anchor.rel = "noopener noreferrer";

        let icon = document.createElement("img");
        icon.src = twitter_icon;
        icon.alt = "Twitter";

        anchor.appendChild(icon);
        social_networks_available.push(anchor);
      }
      if (data.item.youtube_url != null) {
        let anchor = document.createElement("a");
        anchor.href = data.item.youtube_url;
        anchor.target = "_blank";
        anchor.className = "side-menu-social-network";
        anchor.rel = "noopener noreferrer";

        let icon = document.createElement("img");
        icon.src = youtube_icon;
        icon.alt = "Youtube";

        anchor.appendChild(icon);
        social_networks_available.push(anchor);
      }

      let social_network_container = document.getElementById(
        dom_obj.menu_social_network
      );
      social_network_container.innerHTML = "";
      social_networks_available.forEach((item) => {
        social_network_container.appendChild(item);
      });
    }

    return {
      displayTopBanner: (id_entry) => displayTopBanner(id_entry),
      setActivePage: (url) => setActivePage(url),
      setActiveIcon: (activeTab) => setActiveIcon(activeTab),
      showSocialNetworkCompany: (data) => showSocialNetworkCompany(data)
    };
  })();

  var mainController = (function (page_controller, page_view) {
    var setupEventListeners = function () {};
    return {
      init: function () {
        // console.log("Menu started");
        setupEventListeners();
        // page_controller.getBanner(29, page_view.displayTopBanner);
        coffee_tools.showRotateBanner("js__menu_side__banner");
        view.setActivePage(window.location.pathname);
        page_controller.getSocialNetworkCompany(
          page_view.showSocialNetworkCompany
        );
        setShowProgessBar(false);
      }
    };
  })(controller, view);

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar
          className='home_toolbar'
          color={"secondary"}
        >
          <IonButtons slot='start'>
            <IonMenuButton></IonMenuButton>
          </IonButtons>

          <div className='header_lnbp_icon'>
            <img
              src={lnbp_logo}
              alt='LNBP'
            />
          </div>
        </IonToolbar>
      </IonHeader>
      <IonContent>
        <div hidden={!showProgessBar}>
          <IonProgressBar type='indeterminate'></IonProgressBar>
        </div>

        <IonList>
          <IonItem
            routerLink='/home'
            className='side-menu--menu-item'
          >
            <IonIcon
              font-size='48px'
              className='side-menu--icon'
              src={home_icon}
            />
            <IonLabel className='side-menu--options'>Home</IonLabel>
          </IonItem>
          <IonItem
            routerLink='/teams'
            className='side-menu--menu-item'
          >
            <IonIcon
              font-size='48px'
              className='side-menu--icon'
              src={teams_icon}
            />
            <IonLabel className='side-menu--options'>Equipos</IonLabel>
          </IonItem>
          <IonItem
            routerLink='/results'
            className='side-menu--menu-item'
          >
            <IonIcon
              font-size='48px'
              className='side-menu--icon'
              src={score_icon}
            />
            <IonLabel className='side-menu--options'>Resultados</IonLabel>
          </IonItem>
          <IonItem
            routerLink='/leaders'
            className='side-menu--menu-item'
          >
            <IonIcon
              font-size='48px'
              className='side-menu--icon'
              src={leaders_icon}
            />
            <IonLabel className='side-menu--options'>
              Líderes Individuales
            </IonLabel>
          </IonItem>
          <IonItem
            routerLink='/scores'
            className='side-menu--menu-item'
          >
            <IonIcon
              font-size='48px'
              className='side-menu--icon'
              src={tabla_posiciones}
            />
            <IonLabel className='side-menu--options'>
              Tabla de Posiciónes
            </IonLabel>
          </IonItem>
          <IonItem
            routerLink='/calendar'
            className='side-menu--menu-item'
            onClick={() => {
              window.location.href = "/calendar";
            }}
          >
            <IonIcon
              font-size='48px'
              className='side-menu--icon'
              src={calendar_icon}
            />
            <IonLabel className='side-menu--options'>Calendario</IonLabel>
          </IonItem>
          <IonItem
            routerLink='/videos'
            className='side-menu--menu-item'
          >
            <IonIcon
              font-size='48px'
              className='side-menu--icon'
              src={video_icon}
            />
            <IonLabel className='side-menu--options'>Videos</IonLabel>
          </IonItem>
        </IonList>
        <IonList>
          <IonItem
            id='js__menu_social_network'
            className={`ion-text-center ion-item--social`}
          ></IonItem>
          <IonItem
            className={`ion-text-center side-menu-banner-container`}
            style={{ borderColor: "transparent" }}
          >
            <a id='js__banner_image_anchor'>
              <img
                src=''
                className='side-menu-banner'
                id='js__menu_side__banner'
                alt='banner'
              />
            </a>
          </IonItem>
        </IonList>
      </IonContent>
    </IonPage>
  );
};

export default Menu;
